'use client';

import Script from 'next/script';
import {useEffect, useState} from 'react';
import {useAuth} from 'iq-auth';

declare global {
  interface Window {
    clarity?: (...args: Array<unknown>) => void;
  }
}

const CLARITY_ID = process.env.NEXT_PUBLIC_MSCLARITY_ID;

export const Clarity = () => {
  const {user} = useAuth();
  const [load, setLoad] = useState(false);

  useEffect(() => {
    if (!load) setLoad(true);
  }, [load]);

  useEffect(() => {
    // ponytail: best-effort — no-ops if the lazyOnload snippet hasn't run yet.
    window.clarity?.('identify', user.loggedIn ? user.id : 'public');
  }, [user]);

  if (!load || !CLARITY_ID) return null;

  return (
    <Script
      id='clarity-init'
      strategy='lazyOnload'
      dangerouslySetInnerHTML={{
        __html: `
          (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "${CLARITY_ID}")`,
      }}
    />
  );
};
